import * as React from "react";
import { TemplateSub } from "../../../components/layouts/TemplateSub";

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <TemplateSub page="Privacy Policy">
      <div className="px-4 ">
        <div className="flex flex-col mt-[1rem] h-[calc(100vh-180px)] bg-[#1E1E1E] rounded-xl overflow-hidden">
          {/* Scrollable content area */}
          <div className="overflow-y-auto p-6">
            <div className="text-white mb-6" style={{ fontWeight: "bolder" }}>
              Before you proceed, please read this privacy policy.{" "}
            </div>
            {/* <div className="text-white " style={{ fontWeight: "bolder" }}>
              Privacy Policy{" "}
            </div> */}
            <div className="mb-6">
              <p className="text-white">Effective Date: 25/08/2025 </p>
              <p className="text-white mb-6">Last Updated: 26/08/2025 </p>
            </div>

            <p className="text-white ">Welcome to Njoy. </p>
            <p className="text-white mb-6 opacity-80 text-justify">
              At Njoy, your privacy matters to us. This Privacy Policy (the
              “Policy”) explains how we collect, use, share, store, and protect
              your personal information. It also outlines your rights and
              choices in relation to your data, as well as the safeguards we
              have in place to protect it.
            </p>
            <p className="text-white mb-6 opacity-80 text-justify">
              This Policy applies to all users who access our web-app{" "}
              <a
                href="https://app.njoy.live"
                target="_blank"
                rel="noopener noreferrer"
                className="text-indigo-400 hover:underline"
              >
                app.njoy.live
              </a>
              , website at{" "}
              <a
                href="https://njoy.live"
                target="_blank"
                rel="noopener noreferrer"
                className="text-indigo-400 hover:underline"
              >
                njoy.live
              </a>{" "}
              and any related services we provide (collectively, the
              “Services”). Currently, Njoy operates only in Nigeria and our
              Services are available exclusively to users located within
              Nigeria.
            </p>

            <div className="text-white mb-6 opacity-80 text-justify">
              By accessing or using our Services, you acknowledge and agree to
              the practices described in this Policy.{" "}
            </div>

            <ol className="list-decimal pl-6 space-y-8">
              {/* Section 1 */}
              <li className="pl-2 text-white ">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Guiding Principles
                </h2>
                <p className="mb-3 text-white opacity-80">
                  Njoy processes your information in line with the Nigeria Data
                  Protection Act (NDPA) 2023, the NDPA General Application and
                  Implementation Directive (NDPA-GAID) 2025, and other relevant
                  and applicable data protection laws. We are guided by the
                  following principles:
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 text-white opacity-80">
                  <li>
                    Lawfulness, fairness, and transparency - we ensure your data
                    is processed in a lawful, fair, and transparent manner. P
                  </li>
                  <li>
                    Purpose limitation - we only collect data specifically for
                    the purpose(s) it is required for.
                  </li>
                  <li>
                    Data minimization - we collect only what is necessary.
                  </li>
                  <li>Accuracy - we strive to keep your data up to date.</li>
                  <li>
                    Storage limitation - your data is not kept longer than
                    necessary.
                  </li>
                  <li>
                    Integrity and confidentiality - we protect your data against
                    loss, misuse, or unauthorised access.
                  </li>
                  <li>
                    Accountability - we are responsible for complying with these
                    principles and can demonstrate our compliance.
                  </li>
                </ul>
              </li>

              {/* Section 2 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Account Registration
                </h2>
                <div className="mb-3 text-white text-justify opacity-80">
                  We collect information from you in the following categories:
                </div>
                <p className="mb-3 text-white  opacity-80">
                  Personal Information{" "}
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4  opacity-80 text-white">
                  <li>
                    What we collect: Name, email address, address, phone number,
                    date of birth, government-issued or other means of ID and
                    other contact or account details.{" "}
                  </li>
                  <li>
                    Why we collect it: To create and manage your account,
                    communicate with you about updates, merchant offers, and
                    transactions, provide support, and meet legal or contractual
                    obligations.
                  </li>
                  <li>
                    How we collect it: Directly from you when you sign up,
                    contact us, or interact with our Services.
                  </li>
                </ul>
                <p className="mb-3 text-white text-justify opacity-80">
                  Usage Data{" "}
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 opacity-80 text-white">
                  <li>
                    What we collect: Pages visited, features used, session
                    duration, and user actions.
                  </li>
                  <li>
                    Why we collect it: To improve our Services, develop new
                    features, troubleshoot issues, and enhance your user
                    experience.
                  </li>
                  <li>
                    How we collect it: Automatically, when you use our Services.
                  </li>
                </ul>
                <p className="mb-3 text-white opacity-80">
                  Technical/Device Information{" "}
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 opacity-80 text-white">
                  <li>
                    What we collect: IP address, browser type, operating system,
                    and device identifiers.
                  </li>
                  <li>
                    Why we collect it: To secure our Services, prevent fraud,
                    ensure compatibility, and comply with regulatory
                    obligations.
                  </li>
                  <li>
                    How we collect it: Automatically, when you use our Services.
                  </li>
                </ul>
                <p className="mb-3 text-white opacity-80">Location Data </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 opacity-80 text-white">
                  <li>
                    What we collect: We may collect your address if you are
                    merchant partner. If you are using the Services to access
                    perks and benefits, we may collect your location date based
                    on the permissions you enable on your device or state level
                    location.
                  </li>
                  <li>
                    Why we collect it: To provide location-based offers, verify
                    eligibility for services or promotions, and detect fraud.
                  </li>
                  <li>
                    How we collect it: through device permissions you enable,
                    automatically via your IP address or network, or from
                    information you provide.
                  </li>
                </ul>
                <p className="mb-3 text-white opacity-80">
                  Payment or Financial Data{" "}
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 opacity-80 text-white">
                  <li>
                    What we collect: We do not process your payments directly.
                    All payment processing is handled securely by our
                    third-party payment partners. However, we may collect
                    limited transaction-related information made available to us
                    by these partners, such as the amount, product/service
                    purchased, date/time of transaction, and account identifiers
                    (e.g., email address or User ID).
                  </li>
                  <li>
                    Why we collect it: To provide merchants and users with
                    access to transaction history, support reconciliation of
                    accounts, address billing or support inquiries, and comply
                    with applicable legal or regulatory requirements.
                  </li>
                  <li>
                    How we collect it: Through secure integrations with our
                    payment partners, who share relevant transaction records
                    with us for reporting and dashboard display.
                  </li>
                </ul>
                <p className="mb-3 text-white opacity-80">
                  Third-Party Account Data{" "}
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 opacity-80 text-white">
                  <li>
                    What we collect: If you sign up using platforms like Google
                    or Apple, we may receive your name, email, unique
                    identifiers, and authentication tokens necessary for login.
                  </li>
                  <li>
                    Why we collect it: To simplify account creation, login, and
                    verification, and to securely link your third-party account
                    with your Njoy profile.
                  </li>
                </ul>
              </li>

              {/* Section 3 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Cookies & Tracking Technologies
                </h2>
                <div className="mb-3 text-white opacity-80">
                  Cookies are small text files that are stored on your device
                  (such as your phone, tablet, or computer) when you use our
                  Services. They help us remember who you are, make the app run
                  smoothly, and improve your overall experience.
                </div>

                <p className="mb-3 text-white">Types of Cookies We Use:</p>
                <ul className="list-disc pl-6 space-y-2 mb-4 text-white opacity-80">
                  <li>
                    Essential Cookies - These are required for the app or
                    website to work properly (for example, keeping you logged in
                    or remembering your session). Without them, some features
                    will not function.
                  </li>
                  <li>
                    Performance/Analytics Cookies - These help us understand how
                    you use our Services (e.g., which pages or features are most
                    popular) so we can improve them.
                  </li>
                  <li>
                    Functional Cookies - These remember your preferences and
                    settings, such as language or location, to personalize your
                    experience.
                  </li>
                  <li>
                    Marketing/Advertising Cookies - These may be used to show
                    you offers, discounts, or promotions that are more relevant
                    to you.
                  </li>
                </ul>
                <p className="mb-3 text-white">How Cookies Work: </p>
                <div className="mb-3 text-white opacity-80">
                  When you visit or use Njoy, cookies are downloaded to your
                  device. Each time you come back, your device shares these
                  cookies with us, which allows us to recognize you and tailor
                  your experience. Some cookies are temporary (they disappear
                  when you close the browser), while others last longer until
                  they are deleted.
                </div>
                <p className="mb-3 text-white">Managing Cookie Preferences: </p>
                <p className="mb-3 text-white opacity-80">
                  You are in control of your cookies. You can accept or reject
                  cookies when prompted, adjust settings in your browser or
                  device to block, allow, or delete cookies, or opt out of
                  marketing/advertising cookies if you do not want tailored ads.
                  Please note: If you disable certain cookies, parts of our
                  Services may not function as intended.
                </p>
              </li>

              {/* Section 4 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Legal Basis for Processing
                </h2>
                <p className="mb-3 text-white opacity-80">
                  We process your data on the following bases:
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 text-white opacity-80">
                  <li>
                    Consent - when you voluntarily provide information or use
                    our Services, you consent to the terms of this Policy.
                    Please note that you can withdraw your consent at anytime by
                    sending a request to us at contact@njoy.live. If you do not
                    consent to the collection, use or disclosure of your
                    personal information as outlined in this Policy, please do
                    not provide any personal information to Njoy.{" "}
                  </li>
                  <li>
                    Contractual necessity - When you sign up on Njoy, you enter
                    into an agreement with us. To give you access to your
                    account and provide our Services to you, we need to process
                    certain information (like your name, contact details, and
                    login information). Without this, we would not be able to
                    provide the Services you signed up for.{" "}
                  </li>
                  <li>
                    Legal obligation - Sometimes the law requires us to collect
                    or share your information. For example, we may need to keep
                    records of transactions for tax or regulatory purposes or
                    provide information if requested by a government authority
                    or court. In such cases, we only process what is strictly
                    necessary to meet these obligations.{" "}
                  </li>
                  <li>
                    Vital interests - We may process your personal information
                    if necessary to protect your vital interests or the
                    interests of another natural persons. For instance, where
                    you are physically or legally incapable of giving consent
                    such as in the event of a claim for any amounts in a
                    deceased user's wallet by the deceased's next-of-kin.
                  </li>
                  <li>
                    Public interest - On some occasions, we may process your
                    information because it helps us carry out tasks that benefit
                    the public or are required by public authorities. For
                    example, complying with national security or law enforcement
                    requirements.
                  </li>
                  <li>
                    Legitimate interests - Sometimes, we use your information
                    because it benefits both you and us, and does not harm your
                    rights or freedoms. Examples include preventing fraud,
                    improving the security of our Services, analysing usage to
                    improve features, or sending you relevant updates (such as
                    new offers or changes to our Services). Whenever we rely on
                    this basis, we make sure that our use of your information is
                    reasonable, does not contravene other lawful bases, and does
                    not override your fundamental human rights.
                  </li>
                </ul>
              </li>

              {/* Section 5 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  How We Share Your Information
                </h2>
                <p className="mb-3 text-white opacity-80">
                  We may share your Personal Information with:
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 text-white opacity-80">
                  <li>
                    Third-party service providers (e.g., merchants partners
                    (where applicable), payment partners, analytics providers,
                    hosting services).{" "}
                  </li>
                  <li>
                    Business partners and affiliates, such as email service
                    providers that perform marketing services on our behalf, and
                    fraud prevention service providers that use the information
                    to provide services to us.{" "}
                  </li>
                  <li>
                    Selected third parties including business partners,
                    suppliers and sub-contractors for the performance of any
                    contract we enter into with them or you.{" "}
                  </li>
                  <li>
                    In response to a request for information, if we are required
                    by, or we believe disclosure is in accordance with
                    applicable laws, rules, regulations, governmental and
                    quasi-governmental requests, court orders, or subpoenas or
                    legal process.
                  </li>
                  <li>
                    Relevant law enforcement officials or other third parties,
                    such as investigators or auditors, if we believe it is
                    appropriate to investigate fraud.
                  </li>
                  <li>
                    Other users, when you sign up via a referral link, the
                    referrer may be notified.
                  </li>
                  <li>
                    With your consent, when you authorize us to share your data.
                  </li>
                </ul>
              </li>

              {/* Section 6 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Data Retention
                </h2>
                <p className="mb-3 text-white opacity-80">
                  We retain your personal information for as long as necessary
                  to provide our Services, comply with legal obligations,
                  resolve disputes, and enforce agreements. When data is no
                  longer required, it is securely deleted or anonymized.
                </p>
              </li>

              {/* Section 7 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Your Rights
                </h2>
                <p className="mb-3 text-white opacity-80">
                  As a user, you have the right to:{" "}
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4 text-white opacity-80">
                  <li>
                    <span className="underline">
                      Access your personal information.
                    </span>{" "}
                    You can ask us at any time to confirm whether we hold your
                    personal data. If we do, you can request a copy of the
                    information we have about you. For example, you may want to
                    see what details you provided when you signed up or what
                    transaction records are linked to your account. Before
                    sending you any personal information, we will ask you to
                    provide proof of your identity. If you are not able to
                    provide proof of your identity, we reserve the right to
                    refuse to send you any Personal Information.{" "}
                  </li>
                  <li>
                    <span className="underline">
                      Request corrections or updates.
                    </span>{" "}
                    If any of your information is incomplete, out of date, or
                    incorrect (like your phone number or email address), you can
                    ask us to correct or update it. This ensures your account
                    always stays accurate and functional. You can change some of
                    your personal information by updating your account profile
                    through our Services. Changes to financial details will
                    require you to contact us directly. If you are not a user,
                    you can contact us via [.] to make any changes or request on
                    personal information we hold about you. Any changes will
                    affect only future uses of your personal information, and we
                    may need to verify the accuracy of the new data you provide
                    to us.
                  </li>
                  <li>
                    <span className="underline">
                      Request deletion or restriction of processing.
                    </span>{" "}
                    You can ask us to delete your personal information if you no
                    longer want to use our Services or if you believe we should
                    not be holding it. In some cases, instead of full deletion,
                    you can ask us to restrict how we use your data (for
                    example, keeping it only for legal compliance but not for
                    active use in our Services).{" "}
                  </li>
                  <li>
                    <span className="underline">
                      Opt-out of marketing communications.
                    </span>{" "}
                    You can choose not to receive promotional emails, SMS, or
                    push notifications from us. We will still send important
                    service-related messages (such as security alerts or account
                    notices), but you can control marketing messages through
                    your app settings or by clicking “unsubscribe” in
                    communications.{" "}
                  </li>
                  <li>
                    <span className="underline">
                      Request data portability, where applicable.
                    </span>{" "}
                    In certain circumstances you can request to receive a copy
                    of your personal information in a commonly used electronic
                    format. This right only applies to personal information that
                    you have provided to us (for example by completing a form or
                    providing information through our website). Information
                    about you which has been gathered by monitoring your digital
                    behaviour will also be subject to the right to data
                    portability. The right to data portability only applies if
                    the processing is based on your consent or if the personal
                    information must be processed for the performance of a
                    contract and the processing is carried out by automated
                    means (i.e., electronically).{" "}
                  </li>
                  <li>
                    <span className="underline">
                      Request the transfer of your personal information to
                      another party.
                    </span>{" "}
                    We will provide to you, or a third party you have chosen,
                    your personal information in a structured, commonly used,
                    machine-readable format. Note that this right only applies
                    to automated information which you initially provided
                    consent for us to use or where we used the information to
                    perform a contract with you.{" "}
                  </li>
                  <li>
                    <span className="underline">
                      Lodge a complaint with the Nigeria Data Protection
                      Commission (NDPC).
                    </span>{" "}
                    If you believe that the processing of your personal
                    information violates data protection law, you also have the
                    right to complain to the NDPC via this link:{" "}
                    <a
                      href="https://services.ndpc.gov.ng/breach/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-400 hover:underline"
                    >
                      services.ndpc.gov.ng/breach/
                    </a>
                    .{" "}
                  </li>
                  <li>
                    <span className="underline">
                      Right to withdraw consent.
                    </span>{" "}
                    Where we are relying on consent to process your personal
                    information, you may withdraw your consent to the processing
                    of personal information. However, this will not affect the
                    lawfulness of any processing carried out before you withdraw
                    your consent. If you withdraw your consent, we may not be
                    able to provide certain Services to you. We may advise you
                    if this is the case at the time you withdraw your
                    consent.{" "}
                  </li>
                  <li>
                    <span className="underline">
                      Right to object to decisions taken by automated means.
                    </span>{" "}
                    You have the right to object to decisions made solely based
                    on automated processing of personal data, including
                    profiling, that may have a legal effect on you. This means
                    where the decision impacts your legal right i.e. freedom
                    from discrimination or similarly significant effects.
                    However, this right is not absolute where we have your
                    consent, the decision is necessary for entering into or
                    performing a contract with us, where there are appropriate
                    safeguards for your rights. We would implement appropriate
                    measures to protect your rights and interests. These
                    measures include ensuring you can obtain human intervention
                    in the decision-making process, express your views, and
                    contest the decision.{" "}
                  </li>
                </ul>
                <p className="mb-3 text-white opacity-80">
                  To exercise these rights or make any complaints, questions, or
                  requests regarding the processing of your personal
                  information, please reach out to our Data Protection Officer
                  at{" "}
                  <a
                    href="mailto:dataprotection@njoy.live"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-400 hover:underline"
                  >
                    dataprotection@njoy.live
                  </a>
                  . In the event of an infringement of data protection rights,
                  we will ensure any damage is remedied within the shortest
                  possible time.
                </p>
              </li>

              {/* Section 8 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Data Security
                </h2>
                <p className="mb-3 text-white opacity-80">
                  We implement appropriate technical and organizational measures
                  to safeguard your Personal Information, including encryption
                  of sensitive data, strict access controls limited to
                  authorized personnel, and regular monitoring and system
                  testing to prevent unauthorized access.{" "}
                </p>
              </li>

              {/* Section 9 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  International Data Transfers
                </h2>
                <p className="mb-3 text-white opacity-80">
                  If your data is transferred outside Nigeria, we ensure
                  adequate safeguards are in place (such as standard contractual
                  clauses or equivalent measures) to protect your personal
                  information.{" "}
                </p>
              </li>

              {/* Section 10 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Children's Privacy
                </h2>
                <p className="mb-3 text-white opacity-80">
                  Our Services are not directed at individuals under the age of
                  18. We do not knowingly collect personal information from
                  children. If we become aware of such collection, we will
                  delete it promptly. Parents or guardians who believe their
                  child has provided information should contact us
                  immediately.{" "}
                </p>
              </li>

              {/* Section 11 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Changes to this Policy
                </h2>
                <p className="mb-3 text-white opacity-80">
                  We may update this Privacy Policy from time to time to reflect
                  changes in law, technology, or our Services. Any updates will
                  be posted here with the “Effective Date” revised accordingly.
                  In cases of significant changes, we may notify you through
                  email or app notifications.{" "}
                </p>
              </li>

              {/* Section 12 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Contact Us
                </h2>
                <p className="text-white">
                  Email:{" "}
                  <a
                    href="mailto:contact@njoy.live"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-400 hover:underline"
                  >
                    contact@njoy.live
                  </a>
                </p>
                <p className="text-white">
                  Data Protection Officer:{" "}
                  <a
                    href="mailto:dataprotection@njoy.live"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-400 hover:underline"
                  >
                    dataprotection@njoy.live
                  </a>
                </p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </TemplateSub>
  );
};
